<template>
<modal name="account-dialog"
  :adaptive="true"
  :scrollable="true"
  height="auto">
  <div class="v--modal-close-top">
    <el-button @click="closeDialog"
      icon="el-icon-close"
      type="text"></el-button>
  </div>
  <div class="setting">
    <div class="title">
      <h1>設定</h1>
    </div>
    <div v-if="$yagi.isYagiDaikon">🐐大根モードが有効です</div>
    <div class="user-avatar">
      <div class="image">
        <your-yagi :your-yagi-class="{}"
          :yagi-options="{dialogEnabled: true, rubyEnabled: false, messageEnabled: true}"></your-yagi>
      </div>
      <el-form :model="$yagi.profile"
        :rules="yagiRules"
        @submit.native.prevent
        ref="yagiForm">
        <div>
          <el-form-item label="名前"
            prop="name">
            <el-input class="input-md"
              v-model="$yagi.profile.name"></el-input>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="ヤギの色を変える"
            prop="color"
            class="yagi-color-select">
            <ul class="yagi-color-list">
              <li class="yagi-color-item"
                :style="{'background': color}"
                :key="index"
                :index="index"
                @click="$yagi.changeColor(color)"
                v-for="(color, index) in ['white', '#D7D7D7','#E0D0B6','#E3C9C2','#FFD0F6', '#ffffb7', '#b7ffb7', '#c1c1ff', '#1A5234', 'lightcyan', 'skyblue', 'plum', 'gold']">
              </li>
            </ul>
          </el-form-item>
        </div>
      </el-form>

    </div>
    <div v-if="!$deviceLib.isOnline">
      現在オフラインです
    </div>
    <div v-else-if="$firebase.isAuthenticated"
      class="is-authenticated">
      <div class="setting-item login-account">
        <h2>アカウント情報</h2>
        <div class="email"><span v-if="$firebase.user.displayName">{{ $firebase.user.displayName }} </span>[ {{ $firebase.user.email }} ] でログイン中です。</div>
        <!-- <a @click="$firebase.signOut();$event.preventDefault()"
             href="#">ログアウトする</a> -->
        <div class="text-right">
          <el-button id="google-logout-account-dialog"
            @click="$firebase.signOut();$event.preventDefault()">ログアウト</el-button>
        </div>

      </div>

      <h2>バックアップ（β版）</h2>
      <p>入力しているデータをサーバー上に保存して、あとで復元したり、他の端末にデータを引き継ぐことができます。</p>
      <div class="text-right">
        <el-button type="success"
          @click="closeDialog();$router.push({name: 'backupIndex'});">バックアップ画面を開く</el-button>
      </div>
    </div>
    <div v-else
      class="not-authenticated setting-item">
      <h2>ログイン</h2>
      <p>ログインすると入力した内容をサーバーにバックアップしたり、自分のアドレスに履歴書を送信したり、コンビニ印刷のサービスをご利用いただけるようになります。</p>
      <login-forms />
    </div>
    <div class="setting-item data-clear">
      <h2>ブラウザに自動保存</h2>
      <div>
        <el-switch v-model="$yagi.profile.autoSaveEnabled"
          active-text="オン"
          inactive-text="オフ"></el-switch>
      </div>
      <p>データを自動的にブラウザ内（IndexedDB、LocalStorage等）に保存し、ブラウザを閉じたり別のページを開いてしまっても再開できるようになります。 </p>
      <p>共用の端末をご利用の場合は使用後に下記で削除を行うなどご注意ください。保存された内容は自動的に読み込まれます。 </p>
    </div>
    <div class="setting-item">
      <h2>データ・アカウントの削除</h2>
      <p>ブラウザ内に保存されたデータや、サーバーへのバックアップデータ、登録アカウントなどを削除できます。</p>
      <div class="text-right">
        <el-button id="account-delete-account-dialog" type="success"
          @click="closeDialog();$router.push({name: 'accountDelete'});">データ・アカウント削除画面を開く</el-button>
      </div>
    </div>
  </div>

  <div class="text-right">
    <el-button @click="closeDialog">閉じる</el-button>
  </div>
</modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
import LoginForms from '@/components/LoginForms'
export default {
  components: {
    'login-forms': LoginForms
  },
  data: function () {
    return {
      yagiRules: {
        name: [
          {
            required: true,
            message: '名前をいれてね',
            trigger: 'change'
          },
          {
            min: 1,
            max: 16,
            message: '16文字以内にしてね',
            trigger: 'change'
          }]
      },
      clearLocalStorageConfirmVisible: false
    }
  },
  methods: {
    openDialog: function () {
      this.$modal.show('account-dialog')
      this.clearLocalStorageConfirmVisible = false
    },
    closeDialog: function () {
      this.$modal.hide('account-dialog')
      this.clearLocalStorageConfirmVisible = false
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('open-account-dialog', this.openDialog)
    this.$eventHub.$on('popstate', this.closeDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('open-account-dialog', this.openDialog)
    this.$eventHub.$off('popstate', this.closeDialog)
  }
}
</script>
